import Vue from 'vue';
import './config/abp.js';
import {
  router
} from './config/router';
import './config/rem';
import App from './App.vue';
import VueLazyload from 'vue-lazyload'
import components from './config/components.js';
import SignalRAspNetCoreHelper from './config/SignalRAspNetCoreHelper';
import ajax from '@/config/ajax'
import Util from '@/config/Util'
import appconst from "./config/appconst";
import 'vant/lib/index.css';
import './assets/icon/iconfont.css';
import abctheme from "./config/themeconfig";
import 'amfe-flexible'; 
import VueClipboard from 'vue-clipboard2';
import { Popover,ImagePreview } from 'vant';
import longpress from '@/config/longpress';
import {
  baseUrl
} from '@/config/env'
import {
  Dialog
} from 'vant';
import util from './config/Util.js';
Vue.use(Dialog);
Vue.use(components);
Vue.use(VueLazyload)
Vue.use(VueClipboard);
Vue.use(Popover);
Vue.use(ImagePreview);
Vue.prototype.ajax = ajax;
Vue.prototype.abp = Util.abp;
Vue.prototype.$baseurl = appconst.remoteServiceBaseUrl;
Vue.prototype.$abctheme = abctheme;
Vue.prototype.$dialog = Dialog;

Vue.prototype.getQueryVariable = function (variable) {
  var query = window.location.href;
  var len = variable.length + 1;
  var index = query.indexOf(variable + '=');
  if (index == -1) return '';
  var rightIndex = query.indexOf('&', index + len);
  if (rightIndex == -1) {
    rightIndex = query.length;
  }
  return query.substring(index + len, rightIndex);
}

Util.abp.setUrl = function (e) {
  return baseUrl + e;
}
Vue.prototype.getUserInfo=function(){
  return new Promise(function(resolve, reject) {
    // ... some code
    ajax.post('/api/services/app/PhoneUser/QueryUserInfo').then(x=>{
      abp.userInfo=x.result;
      resolve(abp.userInfo); //怎么将这个值作为fn1函数的返回值？
    }).catch((error)=>{
      reject(error);
    })
});
  
}


if(Util.abp.auth.getToken())
{
    ajax.get('/api/TokenAuth/PhoneGetAll').then(x => {
      Util.abp = Util.extend(true, Util.abp, x.result);
      ajax.post('/api/services/app/ShopConfig/QueryModel').then(p=>{
        Util.abp.systemconfig=p.result;
      })
    if (!!Util.abp.session.userId) {
      SignalRAspNetCoreHelper.initSignalR();
      //拉取公告
      ajax.post('/api/services/app/PhoneUser/QueryUserInfo').then(u => {
        Util.abp.userInfo = u.result;
        if(!u.result.memberLevelModel.isRetail&&!u.result.isFirstRecharge && u.result.isEarnestMoney)
        {
            Dialog.confirm({title:'提示',message:'您还未完成首充,点击确定前往充值页面'})
              .then(()=>{
                router.push({
                  name: "rechargemoney",
                  query: {
                    rechargeType: 0,
                  },
                })
              });
            }
            else
            {
                if(u.result.isTBEnter)
                {
                  router.push({
                    name:'earnestwaitcheck'
                  })
                }
              
            }
  
      })
    }
    setTimeout(() => {
      new Vue({
        router,
        el: '#app',
        render: h => h(App),
        mounted() {
          if (!!Util.abp.session.userId) {

            ajax.post('/api/services/app/PhoneCom/QueryMoreNotice').then(x=>
            {
                  var fnmodel=x.result;
                  var znresult=fnmodel.myIdeal;
                  if(znresult.totalNum>0)
                  {
                      Dialog.alert({title:'您有'+znresult.totalNum+'条意见反馈,客服已回复,请查阅'}).then(()=>
                      {
                          if(znresult.totalNum==1)
                          {
                              router.push({name:'idealdetail',query:{id:znresult.idealDto.id}});
                          }
                          else
                          {
                              router.push({name:'ideallist'});
                          }
                      })
                  }
                  var dto=fnmodel.popNotice;
                  if(dto)
                   {
                      Dialog.alert({title:'通知',message:dto.content});
                   }
            });
          
          }
          
        }
      });
    }, 1000);
  
  }).catch(()=>{
    //初始化报错 就直接清除所有缓存
    Util.abp.auth.clearToken();
    //Util.abp.auth.clearAllLocal();
    //localStorage.clear();
    location.reload();
  })
}
else
{
  new Vue({
    router,
    el: '#app',
    render: h => h(App),
    mounted() {

    }
  });
}

